/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import { withRouter } from 'react-router-dom';
import { Grid } from '@mui/material';
import moment from 'moment';
import * as selectorsEquipamentos from '../../../store/equipamento/reducer';
import * as actionsEquipamentos from '../../../store/equipamento/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import {
  InputV2,
  DefaultSelectV2,
  DialogDefaultV2,
  NumberInputV2,
  TrueFalseSelectV2,
  ArquivoContainerV2,
  DatePickerV2,
  UsuarioSelectV2,
} from '../../../components/v2';

const schema = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaRepasse = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  tipoRepasse: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  categoriaRepasse: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  posseEletropontes: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  usuario: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaManutencao = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorManutencao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaVendaTroca = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorRecebido: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const schemaCompra = {
  tipoHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  dataHistorico: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  valorCompra: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
  observacao: {
    presence: { allowEmpty: false, message: 'é obrigatório' },
  },
};

const getSchema = (tipoHistorico) => {
  switch (tipoHistorico) {
    case 'MANUTENCAO':
      return schemaManutencao;
    case 'REPASSE':
      return schemaRepasse;
    case 'VENDA_TROCA':
      return schemaVendaTroca;
    case 'COMPRA':
      return schemaCompra;
    default:
      return schema;
  }
};

const repasse = (values, handleChange, setValues, errors) => (
  <>
    <Grid size={{ xs: 12, sm: 6 }}>
      <UsuarioSelectV2
        label="Colaborador"
        onSelect={(usuario) => setValues({
          ...values,
          usuario,
        })}
        ativo
        value={values.usuario}
        error={!!(errors && errors.usuario)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <InputV2
        label="Região"
        name="regiao"
        onChange={handleChange}
        value={values.regiao || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }}>
      <DefaultSelectV2
        error={!!(errors && errors.tipoRepasse)}
        isRequired
        label="Tipo"
        name="tipoRepasse"
        showEmpty
        options={[
          { id: 'ENTREGA', nome: 'Entrega' },
          { id: 'DEVOLUCAO', nome: 'Devolução' },
        ]}
        onSelect={handleChange}
        value={values.tipoRepasse}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }}>
      <DefaultSelectV2
        error={!!(errors && errors.categoriaRepasse)}
        isRequired
        label="Categoria"
        name="categoriaRepasse"
        showEmpty
        options={[
          { id: 'PRINCIPAL', nome: 'Principal' },
          { id: 'RESERVA', nome: 'Reserva' },
        ]}
        onSelect={handleChange}
        value={values.categoriaRepasse}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 4 }}>
      <TrueFalseSelectV2
        error={!!(errors && errors.posseEletropontes)}
        isRequired
        label="Está com Eletropontes"
        name="posseEletropontes"
        onChange={handleChange}
        value={values.posseEletropontes}
      />
    </Grid>
  </>
);

const manutencao = (values, handleChange, setValues, errors) => (
  <>
    <Grid size={{ xs: 12, sm: 4 }}>
      <NumberInputV2
        prefix="R$"
        label="Valor da Manutenção"
        name="valorManutencao"
        onChange={(valor) => setValues({
          ...values,
          valorManutencao: valor,
        })}
        value={values.valorManutencao}
        decimalScale={2}
        error={!!(errors && errors.valorManutencao)}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <TrueFalseSelectV2
        label="Foi Pago"
        name="pago"
        onChange={handleChange}
        value={values.pago}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 3 }}>
      <TrueFalseSelectV2
        label="Emitiu Nota Fiscal"
        onChange={handleChange}
        name="notaFiscal"
        value={values.notaFiscal}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <InputV2
        label="Profissional Responsável"
        name="profissionalResponsavel"
        onChange={handleChange}
        value={values.profissionalResponsavel || ''}
      />
    </Grid>
    <Grid size={{ xs: 12, sm: 6 }}>
      <InputV2
        label="Empresa"
        name="empresa"
        onChange={handleChange}
        value={values.empresa || ''}
      />
    </Grid>
  </>
);

const vendaTroca = (values, setValues, errors) => (
  <Grid size={{ xs: 12 }}>
    <NumberInputV2
      prefix="R$"
      label="Valor Recebido"
      name="valorRecebido"
      onChange={(valor) => setValues({
        ...values,
        valorRecebido: valor,
      })}
      value={values.valorRecebido}
      decimalScale={2}
      error={!!(errors && errors.valorRecebido)}
    />
  </Grid>
);

const compra = (values, setValues, errors) => (
  <Grid size={{ xs: 12 }}>
    <NumberInputV2
      prefix="R$"
      label="Valor Compra"
      name="valorCompra"
      onChange={(valorCompra) => setValues({
        ...values,
        valorCompra,
      })}
      value={values.valorCompra}
      decimalScale={2}
      error={!!(errors && errors.valorCompra)}
    />
  </Grid>
);

const HistoricoEquipamentosModal = ({
  upsertHistorico,
  selectedHistoricoEquipamento,
  open,
  id,
  onClose,
  findHistoricoById,
  authData,
  idEquipamento,
  afterSave,
}) => {
  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (open) {
      setValues({
        criadoPor: authData.id,
        criadoPorName: authData.nome,
        dataInclusao: moment().format('DD/MM/YYYY HH:mm:ss'),
      });
    } else {
      setValues({});
    }
  }, [authData, open]);

  useEffect(() => {
    if (id) findHistoricoById(id);
  }, [id, findHistoricoById]);

  useEffect(() => {
    if (id && selectedHistoricoEquipamento && id === selectedHistoricoEquipamento.id) {
      setValues(selectedHistoricoEquipamento);
    }
  }, [id, selectedHistoricoEquipamento]);

  const onSave = () => {
    const erros = validate(values, getSchema(values.tipoHistorico));
    setErrors(erros);
    if (!erros) {
      upsertHistorico({
        ...values,
        equipamento: idEquipamento,
      }, saveCallback);
    }
  };

  const saveCallback = (success, data) => {
    if (success) {
      setValues({});
      onCloseLocal(true);
      afterSave(data);
    }
  };

  const onCloseLocal = (isSave) => {
    setErrors({});
    onClose(isSave);
  };

  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value,
    });
  };

  const handleChangeTipo = (event) => {
    setValues((prev) => ({
      id: prev.id,
      criadoPor: prev.criadoPor,
      criadoPorName: prev.criadoPorName,
      dataInclusao: prev.dataInclusao,
      arquivos: prev.arquivos,
      tipoHistorico: event.target.value,
    }));
    setErrors({});
  };

  const titleData = () => {
    switch (values.tipoHistorico) {
      case 'MANUTENCAO':
        return 'Data da Manutenção';
      case 'REPASSE':
        return 'Data da Entrega';
      case 'VENDA_TROCA':
      case 'COMPRA':
        return 'Data da Transferência';
      default:
        return 'Data';
    }
  };

  const titleObservacao = () => {
    switch (values.tipoHistorico) {
      case 'MANUTENCAO':
        return 'Manutenção Realizada';
      case 'VENDA_TROCA':
      case 'COMPRA':
        return 'Negociação (Observação/Detalhes)';
      default:
        return 'Observação';
    }
  };

  return (
    <DialogDefaultV2
      open={open}
      handlerCancel={() => onCloseLocal(false)}
      handlerConfirm={onSave}
      title="Histórico de Equipamentos"
      confirmMessage="Salvar"
      maxWidth="md"
      fullWidth
    >
      <Grid container spacing={1}>
        <Grid size={{ xs: 12, sm: 3 }}>
          <DefaultSelectV2
            error={!!(errors && errors.tipoHistorico)}
            isRequired
            label="Tipo do Histórico"
            name="tipoHistorico"
            showEmpty
            options={[
              { id: 'COMPRA', nome: 'Compra' },
              { id: 'MANUTENCAO', nome: 'Manutenção' },
              { id: 'REPASSE', nome: 'Repasse' },
              { id: 'SUCATA', nome: 'Sucata' },
              { id: 'VENDA_TROCA', nome: 'Venda/Troca' },
            ]}
            onSelect={handleChangeTipo}
            value={values.tipoHistorico}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <DatePickerV2
            label={titleData()}
            error={!!(errors && errors.dataHistorico)}
            onChange={(data) => setValues({
              ...values,
              dataHistorico: data,
            })}
            value={values.dataHistorico}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Criado Por"
            disabled
            value={values.criadoPorName || ''}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 3 }}>
          <InputV2
            label="Data Inclusão"
            disabled
            value={values.dataInclusao || ''}
          />
        </Grid>
        {values.tipoHistorico === 'MANUTENCAO' && manutencao(values, handleChange, setValues, errors)}
        {values.tipoHistorico === 'REPASSE' && repasse(values, handleChange, setValues, errors)}
        {values.tipoHistorico === 'VENDA_TROCA' && vendaTroca(values, setValues, errors)}
        {values.tipoHistorico === 'COMPRA' && compra(values, setValues, errors)}
        {values.tipoHistorico && (
          <Grid size={{ xs: 12 }}>
            <InputV2
              label={titleObservacao()}
              name="observacao"
              onChange={handleChange}
              value={values.observacao || ''}
              rows={3}
              multiline
              error={!!(
                errors
                && errors.observacao
                && (values.tipoHistorico === 'MANUTENCAO' || values.tipoHistorico === 'VENDA_TROCA')
              )}
            />
          </Grid>
        )}
        <Grid size={{ xs: 12 }}>
          <ArquivoContainerV2
            arquivos={values.arquivos}
            onSave={(arquivos) => setValues({ ...values, arquivos })}
          />
        </Grid>
      </Grid>
    </DialogDefaultV2>
  );
};

HistoricoEquipamentosModal.propTypes = {
  upsertHistorico: PropTypes.func.isRequired,
  findHistoricoById: PropTypes.func.isRequired,
  selectedHistoricoEquipamento: PropTypes.object,
  open: PropTypes.bool,
  id: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  authData: PropTypes.object,
  idEquipamento: PropTypes.string,
  afterSave: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  selectedHistoricoEquipamento: selectorsEquipamentos.getSelectedHistoricoEquipamento(state),
  authData: selectorsAuth.getAuth(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsEquipamentos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(HistoricoEquipamentosModal));
